export const base64ImageJPEG = "data:image/jpeg;base64,";
export const base64ImagePNG = "data:image/png;base64,";
export const base64ImageRegex = /^data:image\/[a-z]+;base64,/;
